(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .controller('RecomUpdateStatusAssessByActionPlanAssessmentReviewController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$mdToast', 'recomActionPlanUpdateStatusService'];

    function Controller($rootScope, $scope, $state, $mdToast, recomActionPlanUpdateStatusService) {

        $scope.readOnly = isReadOnly();

        $scope.completionStatuses = [];
        recomActionPlanUpdateStatusService
            .getActionPlanUpdateStatusLookups()
            .then(function (containerPlanLookups) {
                $scope.completionStatuses = containerPlanLookups.CompletionStatuses;
            });

        if ($scope.actionPlanAssessment.ReviewComputedTargetDate) $scope.actionPlanAssessment.ReviewTargetDate = moment($scope.actionPlanAssessment.ReviewComputedTargetDate).format();

        // Show Completion Status?
        $scope.showCompletionStatus = function (completionStatus) {
            if (_.isUndefined($scope.actionPlanAssessment.ReviewCompletionStatusID)) return true;

            return completionStatus.LookupAttributeValueID === $scope.actionPlanAssessment.ReviewCompletionStatusID;
        };

        // Select Completion Status
        $scope.selectCompletionStatus = function (completionStatus) {
            if ($scope.readOnly) return;

            $scope.pageIsDirty();

            if ($scope.isCompletionStatusSelected()) {
                $scope.actionPlanAssessment.ReviewCompletionStatusID = undefined;
                $scope.actionPlanAssessment.ReviewCompletionDate = undefined;
                return;
            }

            $scope.actionPlanAssessment.ReviewCompletionStatusID = completionStatus.LookupAttributeValueID;

            if ($scope.isFieldRequired('ReviewTargetDate') && _.isUndefined($scope.actionPlanAssessment.ReviewTargetDate)) {
                $scope.actionPlanAssessment.ReviewTargetDate = $scope.actionPlanAssessment.ReviewComputedTargetDate;
            }

        };

        $scope.isCompletionStatusSelected = function () {
            return !_.isUndefined($scope.actionPlanAssessment.ReviewCompletionStatusID);
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            if ($scope.readOnly) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Show Review & Continue Action?
        $scope.showReviewAndContinueAction = function () {
            if ($scope.readOnly) return false;

            return $scope.isCompletionStatusSelected();
        };

        // Page is dirty
        $scope.ctxtCtrl = {};
        $scope.ctxtCtrl.needSaveChanges = false;
        $scope.ctxtCtrl.isLoading = false;

        $scope.pageIsDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Reset forms
        $scope.reset = function () {
            if ($scope.readOnly) return;

            $state.reload();
        };

        // Is Review And Continue Disabled?
        $scope.isReviewAndContinueDisabled = function (form) {
            if ($scope.readOnly) return true;
            if (!$scope.isCompletionStatusSelected()) return true;

            return form.$invalid;
        };

        // Is Field Required?
        $scope.isFieldRequired = function (fieldName) {
            if (_.isUndefined(fieldName)) return false;
            if (_.isUndefined($scope.actionPlanAssessment.ReviewFieldConditions_ByCompletionStatusID)) return false;

            var conditionsByCompStatusID = $scope.actionPlanAssessment.ReviewFieldConditions_ByCompletionStatusID;
            var compStatusID = $scope.actionPlanAssessment.ReviewCompletionStatusID;
            if (_.isNumber(compStatusID)) compStatusID = compStatusID.toString();

            var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

            if (_.isUndefined(fieldConditions)) return false;

            return fieldConditions['required'];
        };

        // Review and Continue
        $scope.reviewAndContinue = function (form) {
            if ($scope.readOnly) return;

            if ($scope.isReviewAndContinueDisabled(form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                return;
            };
            $scope.ctrlCtxt.showSubmitError = false;

            $scope.ctxtCtrl.isLoading = true;


            recomActionPlanUpdateStatusService
                .reviewActionPlanAssessment($scope.actionPlan.RecomBusinessUnitID,
                                            $scope.actionPlan.ActionPlanID,
                                            $scope.actionPlanAssessment)
                .then(function (updActionPlanAssessment) {
                    $scope.pageIsNotDirty();

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Action plan has been reviewed')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $scope.actionPlanAssessment = updActionPlanAssessment;

                    var initIdx = _.findIndex($scope.actionPlanStatusList, {
                        ActionPlan: { ActionPlanID: $scope.actionPlan.ActionPlanID }
                    });
                    $scope.actionPlanStatusList[initIdx].ActionPlanAssessment = updActionPlanAssessment;

                    var haveAllActionPlansBeenReviewed = _.every($scope.actionPlanStatusList, {
                        ActionPlanAssessment: { IsReviewed: true }
                    });

                    if (haveAllActionPlansBeenReviewed) {
                        $state.go('actionPlanUpdateStatusOwnerList', { BusinessUnitCode: $scope.bUnit.Code });
                        return;
                    }

                    initIdx += 1;
                    if (initIdx === $scope.actionPlanStatusList.length) initIdx = 0;

                    $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias', {
                        ActionPlanID: $scope.actionPlanStatusList[initIdx].ActionPlan.ActionPlanID
                    });
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Unlock Action Plan
        $scope.unlockActionPlan = function () {
            if (!$scope.actionPlanAssessment.IsLocked) return;

            $scope.ctxtCtrl.isLoading = true;

            recomActionPlanUpdateStatusService
                .unlockActionPlanAssessment(
                    $scope.actionPlan.RecomBusinessUnitID,
                    $scope.actionPlan.ActionPlanID,
                    $scope.actionPlanAssessment)
                .then(function (assessmentByAssessor) {
                    var initIdx = _.findIndex($scope.actionPlanStatusList, {
                        ActionPlanAssessment: { ActionPlanAssessmentID: $scope.actionPlanAssessment.ActionPlanAssessmentID }
                    });

                    $scope.actionPlanAssessment = assessmentByAssessor.ActionPlanAssessment;
                    $scope.actionPlanStatusList[initIdx].ActionPlanAssessment = $scope.actionPlanAssessment;
                    $scope.readOnly = isReadOnly();

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Action plan has been unlocked')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $state.reload();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Go to Criterias
        $scope.goToCriterias = function () {
            if (!$scope.aPlanAssessmentSummary.UseByQuarterPaging) {
                $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias', {
                    ActionPlanID: $scope.actionPlan.ActionPlanID
                }, {
                    reload: true
                });

                return;
            }

            var lastFiscalYearQuarterKey = _.last($scope.ctrlCtxt.fiscalYearQuarterKeys);

            if (!lastFiscalYearQuarterKey) {

                // Will handle no criterias in the future
                $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias', {
                    ActionPlanID: $scope.actionPlanAssessment.ActionPlanID,
                });

                return;
            }

            $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriteriasByQuarter', {
                ActionPlanID: $scope.actionPlanAssessment.ActionPlanID,
                FiscalYearQuarterKey: lastFiscalYearQuarterKey
            });
        };

        function isReadOnly() {
            return !$scope.actionPlanAssessment.IsLocked;
        }
    }
})();